import { cn } from "@design-system/utils";
import * as React from "react";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ toastOptions, ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      className="toaster group"
      style={
        {
          // Default/normal toast
          "--normal-bg": "var(--colors-shape-neutral-outlined-background)",
          "--normal-text":
            "var(--colors-shape-neutral-outlined-foreground-default)",
          "--normal-border":
            "var(--colors-shape-neutral-outlined-border-default)",

          // Success toast
          "--success-bg": "var(--colors-shape-success-outlined-background)",
          "--success-text":
            "var(--colors-shape-success-outlined-foreground-default)",
          "--success-border":
            "var(--colors-shape-success-outlined-border-default)",

          // Error toast
          "--error-bg": "var(--colors-shape-critical-outlined-background)",
          "--error-text":
            "var(--colors-shape-critical-outlined-foreground-default)",
          "--error-border":
            "var(--colors-shape-critical-outlined-border-default)",

          // Warning toast
          "--warning-bg": "var(--colors-shape-warning-outlined-background)",
          "--warning-text":
            "var(--colors-shape-warning-outlined-foreground-default)",
          "--warning-border":
            "var(--colors-shape-warning-outlined-border-default)",

          // Info toast (uses neutral semantic like default)
          "--info-bg": "var(--colors-shape-neutral-outlined-background)",
          "--info-text":
            "var(--colors-shape-neutral-outlined-foreground-default)",
          "--info-border":
            "var(--colors-shape-neutral-outlined-border-default)",
        } as React.CSSProperties
      }
      toastOptions={{
        ...toastOptions,
        classNames: {
          ...toastOptions?.classNames,
          description: cn(
            "text-foreground-neutral-muted!",
            toastOptions?.classNames?.description
          ),
        },
      }}
      {...props}
    />
  );
};
export { Toaster };
